import { IconSparkles } from '@tabler/icons-react'
import { cn } from '#src/cn.ts'
import type { SkillTone } from '#src/components/ai-elements/Skill/types.ts'

type GlyphSize = 'xs' | 'sm' | 'md' | 'lg'

const GLYPH_SIZE: Record<GlyphSize, { box: string; icon: string }> = {
  xs: { box: 'size-5 rounded-[6px]', icon: 'size-3' },
  sm: { box: 'size-7 rounded-md', icon: 'size-4' },
  md: { box: 'size-9 rounded-lg', icon: 'size-[18px]' },
  lg: { box: 'size-11 rounded-xl', icon: 'size-5' },
}

const GLYPH_TONE: Record<SkillTone, string> = {
  default: 'bg-primary/10 text-primary ring-primary/20',
  onPrimary:
    'bg-primary-foreground/20 text-primary-foreground ring-primary-foreground/30',
}

/*
 * The single recurring "skill" mark — a tinted tile with a spark. Used in the
 * chip, picker rows, list, and editor so a skill is instantly recognizable
 * everywhere it appears.
 */
export function SkillGlyph({
  size = 'sm',
  tone = 'default',
  className,
}: {
  size?: GlyphSize
  tone?: SkillTone
  className?: string
}) {
  const s = GLYPH_SIZE[size]
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center justify-center ring-1 ring-inset',
        GLYPH_TONE[tone],
        s.box,
        className
      )}
    >
      <IconSparkles className={s.icon} />
    </span>
  )
}
